import { render } from "./BecomeAServiceCenter.vue?vue&type=template&id=502a217b&scoped=true"
import script from "./BecomeAServiceCenter.vue?vue&type=script&lang=js"
export * from "./BecomeAServiceCenter.vue?vue&type=script&lang=js"

import "./BecomeAServiceCenter.vue?vue&type=style&index=0&id=502a217b&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502a217b"]])

export default __exports__